import { usePastShiftsTab } from '../../../../ui/features/mission-details/hooks/usePastShiftsTab';
import { VolunteerHoursShiftView } from '../../../../ui/features/time-tracking/components/VolunteerHoursShiftView';
import { VolunteerHoursVolunteersView } from '../../../../ui/features/time-tracking/components/VolunteerHoursVolunteersView';
import { Box } from '@mui/material';
import React from 'react';
export const VolunteerHours = () => {
    const { pastShiftTab, setPastShiftTab } = usePastShiftsTab();
    return (React.createElement(Box, { pb: 4 },
        pastShiftTab === 'shift' && React.createElement(VolunteerHoursShiftView, { pastShiftTab: pastShiftTab, setPastShiftTab: setPastShiftTab }),
        pastShiftTab === 'volunteers' && (React.createElement(VolunteerHoursVolunteersView, { pastShiftTab: pastShiftTab, setPastShiftTab: setPastShiftTab }))));
};
